<style lang="scss" scoped>
/deep/ .comp-employee-leave-dialog {
    max-width: 460px;
}
</style>

<template>
    <div class="comp-employee-leave">
        <el-dialog title="办理离职" custom-class="c-el-dialog comp-employee-leave-dialog" :visible.sync="showDialog"
            :before-close="_close" :close-on-click-modal="false">
            <el-form :model="dialogData" :rules="formRules" :ref="formRefName" label-width="100px" size="small">
                <el-col :xs="24">
                    <el-form-item label="员工姓名">
                        <el-input class="c-pw100" :value="dialogData.name" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="身份证号">
                        <el-input class="c-pw100" :value="dialogData.idNumber" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="最后工作日" prop="effectiveDate">
                        <el-date-picker class="c-pw100" v-model="dialogData.effectiveDate" type="date"
                            placeholder="请选择最后工作日（计薪截止日）" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="备注">
                        <el-input class="c-pw100" type="textarea" :rows="2" v-model="dialogData.remark"
                            placeholder="选填"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="_close()">取消</el-button>
                <el-button size="small" type="primary" @click="_save()">确认离职</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import enumConfigs from "@/mixins/enumConfigs"
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeLeave",
    mixins: [enumConfigs],
    data() {
        return {
            showDialog: false,
            defaultDialogData: {
                idNumber: "",
                name: "",
                effectiveDate: "",
                remark: ""
            },
            dialogData: {},
            formRefName: "refEmployeeLeave",
            formRules: {
                effectiveDate: [{ required: true, message: "请选择最后工作日", trigger: ["change"] }]
            }
        }
    },
    methods: {
        open(row) {
            this.dialogData = JSON.parse(JSON.stringify(this.defaultDialogData))
            if (row && row.idNumber) {
                this.dialogData.idNumber = row.idNumber
                this.dialogData.name = row.name
            }
            this.dialogData.effectiveDate = moment().format("YYYY-MM-DD")
            this.showDialog = true
        },
        _save() {
            this.$refs[this.formRefName].validate(valid => {
                if (valid) {
                    window.$common.fullLoading()
                    funEmployee.CreateEmployeeEmploymentRecord({
                        type: this.valEmployeeRecordTypeLeave(),
                        idNumber: this.dialogData.idNumber,
                        effectiveDate: this.dialogData.effectiveDate,
                        remark: this.dialogData.remark
                    }).then(() => {
                        this.commonSuccess("离职成功!")
                    })
                }
            })
        },
        _close() {
            this.showDialog = false
            this.$nextTick(() => {
                if (this.$refs[this.formRefName]) {
                    this.$refs[this.formRefName].resetFields()
                }
            })
        },
        commonSuccess(val) {
            this.alert(val || "操作成功!").then(() => {
                window.$common.closeFullLoading()
                this._close()
                this.refreshData()
            })
        },
        refreshData() {
            this.$emit("refreshData", this.dialogData)
        }
    }
}
</script>
